import {gql} from 'apollo-angular';
import {baseResponseGraphqlField} from '../../../base.graphql';

export const sectorField = `
id
sectorUniqueId
sectorName
sectorIcon
`;

export const GET_ALL_CITIZEN_SECTOR = gql`
query CitizenGetAllSectors($filtering: String){
    citizenGetAllSectors(filtering:$filtering){
    ${baseResponseGraphqlField}
    data {
      ${sectorField}
    }
  }
}
`;
